import { Components } from '@mui/material';
import { ArrowDownIcon } from '@components/icons/svg-icon.tsx';
import checkIcon from '@assets/icons/check.svg';

const muiInputStyles: Components = {
  MuiInput: {
    styleOverrides: {
      root: {
        borderRadius: '7px',
        fontSize: '16px',
        borderColor: 'var(--gray-6)'
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: '7px',
        fontSize: '18px',
        '@media (max-width: 1715px)': {
          fontSize: '14px'
        },
        '&.MuiInputBase-multiline': {
          padding: '0 !important'
        },
        '& .MuiInputBase-input': {
          padding: '13.5px 14px',
          '@media (max-width: 1715px)': {
            padding: '12px 14px'
          }
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '7px',
          borderColor: 'var(--gray-6)'
        },

        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--gray-6)'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderWidth: '1.5px',
          borderColor: 'var(--primary)'
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: 'red'
        },
        '&.search-input': {
          borderRadius: '40px',
          paddingLeft: '22px',
          minWidth: '347px',
          borderColor: 'var(--gray-6)',
          backgroundColor: 'var(--gray-11)',
          '& .MuiOutlinedInput-notchedOutline': {
            borderRadius: '40px'
          }
        }
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      root: {
        fontSize: '18px',
        '@media (max-width: 1715px)': {
          fontSize: '14px'
        },
        marginBottom: '4px',
        paddingLeft: '5px',
        color: 'var(--dark-1)',
        '&.Mui-error': {
          color: 'red',
          '& .reuqired-symbole': {
            color: 'red'
          }
        }
      }
    }
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        minHeight: '20px',
        fontSize: '14px',
        opacity: 0,
        transform: 'translateY(-5px)',
        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
        '@media (max-width: 1715px)': {
          fontSize: '12px',
          minHeight: '16px',
          lineHeight: '16px'
        },
        '&.Mui-error': {
          color: 'red',
          opacity: 1,
          transform: 'translateY(0)',
          '& ~ .MuiFormLabel-root .reuqired-symbole': {
            color: 'red'
          }
        }
      }
    }
  },
  MuiSelect: {
    defaultProps: {
      IconComponent: ArrowDownIcon
    },
    styleOverrides: {
      icon: {
        width: 18,
        // fontSize: '18px !important',
        right: 20
      },
      root: {
        '&.no-border': {
          '& .MuiInputBase-input': {
            padding: 0
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
            padding: 0
          }
        }
      }
    }
  },
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          padding: '4px',
          rowGap: '6px'
        },
        '& .MuiAutocomplete-tag': {
          margin: 0,
          marginInlineStart: '3px'
        },
        '& .MuiChip-deleteIcon': {
          margin: '0 0 0 -6px !important'
        },
        '& .MuiChip-label': {
          paddingLeft: '1px'
        }
      },
      inputRoot: {
        '& .MuiInputBase-input': {
          padding: '9.5px 14px',
          '@media (max-width: 1715px)': {
            padding: '8px 14px'
          }
        }
      },
      paper: {
        fontSize: '16px',
        '@media (max-width: 1715px)': {
          fontSize: '14px'
        }
      },
      popupIndicator: {
        '&:hover': {
          backgroundColor: 'transparent'
        },
        '.MuiTouchRipple-root': {
          display: 'none'
        }
      },
      option: {
        position: 'relative',
        padding: '8px !important',
        '&[aria-selected="true"]': {
          backgroundColor: 'transparent !important'
        },
        // '&[aria-selected="true"] .option-label::after': {
        //   content: '""',
        //   position: 'absolute',
        //   right: '16px',
        //   top: '50%',
        //   transform: 'translateY(-50%)',
        //   width: '16px',
        //   height: '16px',
        //   maskImage: `url("${checkIcon}")`,
        //   WebkitMaskImage: `url("${checkIcon}")`,
        //   maskRepeat: 'no-repeat',
        //   WebkitMaskRepeat: 'no-repeat',
        //   maskSize: 'contain',
        //   WebkitMaskSize: 'contain',
        //   backgroundColor: 'var(--primary)',
        //   '@media (max-width:1715px)': {
        //     width: '13px',
        //     height: '13px'
        //   }
        // },
        '&[aria-selected="true"]::after': {
          content: '""',
          position: 'absolute',
          right: '16px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '16px',
          height: '16px',
          maskImage: `url("${checkIcon}")`,
          WebkitMaskImage: `url("${checkIcon}")`,
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat',
          maskSize: 'contain',
          WebkitMaskSize: 'contain',
          backgroundColor: 'var(--primary)',
          '@media (max-width:1715px)': {
            width: '13px',
            height: '13px'
          }
        },
        '&:hover': {
          color: 'var(--primary) !important',
          backgroundColor: 'var(--gray-11) !important'
        }
      }
    }
  }
};

export default muiInputStyles;
